import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import { setBreadcrumbs } from 'slices/config';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_RESUME_PROFILE_TEST_RESULT';
export const single = 'SINGLE_RESUME_PROFILE_TEST_RESULT';

export const resumeProfileTestResultsApi = createApi({
  reducerPath: 'resumeProfileTestResultsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createResumeProfileTestResult: builder.mutation({
      query: (body) => ({
        url: '/resume-profile-test-results/create',
        method: 'POST',
        body: body
      }),
      invalidatesTags: [list]
    }),
    submitResumeProfileTestResult: builder.mutation({
      query: ({ id, ...attributes }) => ({
        url: `/resume-profile-test-results/submit/${id}`,
        method: 'PUT',
        body: { ...attributes }
      }),
      invalidatesTags: [single]
    }),
    getResumeProfileTestResultById: builder.query({
      query: ({ id, archived }) => ({ url: `/resume-profile-test-results/view/${id}`, ...(archived && { params: { archived: 1 } }) }),
      providesTags: [single],
      async onQueryStarted(_, { dispatch, getState, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (getState().auth?.isLoggedIn && data?.data?.status === 'evaluated') {
            dispatch(setBreadcrumbs(`${data?.data?.email}/${data?.data?.referenceName ?? 'N/A'}`));
          }
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    unarchiveResumeProfileTestResult: builder.mutation({
      query: (ids) => ({
        url: `/resume-profile-test-results/unarchive`,
        method: 'POST',
        body: {
          ids
        }
      }),
      async onQueryStarted(ids, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            resumeProfileTestResultsApi.util.updateQueryData('listResumeProfileTestResults', undefined, (draft) => {
              draft.data.items = draft.data.items.filter((item) => !ids.includes(item.id));
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    listResumeProfileTestResults: builder.query({
      query: (params) => ({
        url: '/resume-profile-test-results/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    }),
    exportResumeProfileTestResults: builder.query({
      query: (params) => ({
        url: '/resume-profile-test-results/export',
        params: { ...params },
        responseHandler: (response) => response.text()
      })
    })
  })
});

export const {
  useCreateResumeProfileTestResultMutation,
  useSubmitResumeProfileTestResultMutation,
  useUnarchiveResumeProfileTestResultMutation,
  useGetResumeProfileTestResultByIdQuery,
  useListResumeProfileTestResultsQuery,
  useExportResumeProfileTestResultsQuery,
  useLazyExportResumeProfileTestResultsQuery
} = resumeProfileTestResultsApi;
